export default __webpack_public_path__ + "static/media/Children_img.62b3a5ad.svg";